import { Col, Form, Input, Modal, Row, TimePicker } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { CreateStoreDto } from "../../entities/dto/store.dto";
import { Store } from "../../entities/interfaces/stores";
import StoreService from "../../services/stores.service";

type Props = {
  open: boolean;
  selected?: Store;
  onChange: () => void;
  onClose: () => void;
};

const ManageStore = ({ open, onChange, selected, onClose }: Props) => {
  const [form] = Form.useForm<any>();
  const isCreate = !selected;
  const title = isCreate ? "Create Store" : "Update Store";
  const okButtonText = isCreate ? "Create" : "Update";
  if (!isCreate) {
    form.setFieldsValue({
      ...selected,
      openingTime: dayjs(selected.openingTime),
      closingTime: dayjs(selected.closingTime),
    });
  }

  const handleSubmit = async (values: CreateStoreDto) => {
    const res = isCreate
      ? await StoreService.create(values)
      : await StoreService.update(selected.id, values);

    if (res?.success) {
      isCreate
        ? toast.success("Store created")
        : toast.success("Store updated");
      onChange();
      closeModal();
    }
  };

  const closeModal = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={form.submit}
      onCancel={closeModal}
      centered
      okText={okButtonText}
      width={700}
    >
      <Form
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
      >
        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please input name!" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item
              label="Address"
              name="address"
              rules={[{ required: true, message: "Please input address!" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item
              label="City"
              name="city"
              rules={[{ required: true, message: "Please input city!" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item
              label="State"
              name="state"
              rules={[{ required: true, message: "Please input state!" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item
              label="Country"
              name="country"
              rules={[{ required: true, message: "Please input country!" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item
              label="Postal Code"
              name="postalCode"
              rules={[{ required: true, message: "Please input postal code!" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item
              label="Contact Number"
              name="contactNumber"
              rules={[
                { required: true, message: "Please input contact number!" },
              ]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item label="Gst Number" name="gstNumber">
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item
              label="Opening time"
              name="openingTime"
              rules={[
                { required: true, message: "Please input opening time!" },
              ]}
            >
              <TimePicker format={"HH:mm:a"} className="w-full" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item
              label="Closing time"
              name="closingTime"
              rules={[
                {
                  required: true,
                  message: "Please input postal closing time!",
                },
              ]}
            >
              <TimePicker format={"HH:mm:a"} className="w-full" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ManageStore;
